import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full"
}
const _hoisted_2 = { class: "flex gap-x-1 flex-wrap mb-2 w-full justify-center" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src", "srcset"]
const _hoisted_5 = { class: "text-parameter-text text-[10px] overflow-hidden max-w-14 mx-auto text-center mt-1" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src", "srcset"]
const _hoisted_8 = { class: "text-parameter-text text-[10px] overflow-hidden max-w-14 mx-auto text-center mt-1" }

import {computed, inject, ref, watch} from "vue";
import {useStore} from "vuex";
import {ParametersVariations} from "@/assets/ts/parametersVariations";

const variantIdx = ""

const minVariantsToShow = 2


export default /*@__PURE__*/_defineComponent({
  __name: 'itemV3StonesForm',
  props: {
    groupIdx: {},
    focusForm: {}
  },
  emits: ["patch"],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emit = __emit;

const store = useStore();

const loadItemVariants = inject<any>("loadItemVariants");

const itemIdx = inject<any>("itemIdx");
const session = inject<any>("session");

/**
 * session
 *
 * Transferred from itemV3StonesSetting.vue: configureAll/itemIdx are wired into
 * ParametersVariations the same way, the variant is fetched per stone group via
 * getItemVariants(itemIdx, "stones.<groupIdx>.stone_form") instead of a fixed idx.
 */

const configureAll = computed(() => store.getters["session/getConfigureAll"])
const parametersVariations = new ParametersVariations(variantIdx, configureAll, session, itemIdx, loadItemVariants)

/**
 * stone form - stones.<groupIdx>.stone_form
 */

const stoneForm = ref({
  "stone_form": {}
} as any)

const getStoneFormData = (groupIdy: number) => {
  if (groupIdy >= 0) {
    stoneForm.value.stone_form = parametersVariations.getItemVariants(itemIdx.value, "stones." + groupIdy + ".stone_form")
  }
}

watch(() => props.groupIdx, (groupIdy) => {
  getStoneFormData(groupIdy)
}, {immediate: true})

watch(session, () => {
  getStoneFormData(props.groupIdx)
}, {deep: true})

/**
 * form variants (transferred from itemV3StonesSetting.vue's "setting variants")
 */

const active = computed(() => stoneForm.value.stone_form[0])

const variantsList = computed(() => active.value?.values || [])

// minimum amount of values the variant list needs (after focusValueIdx is applied) before
// the component is shown - until then the whole component stays invisible (v-if = false)
const matchedIdx = computed(() => variantsList.value.findIndex((v: any) => v.match))

/*
 * focus values (transferred from itemV3StonesSetting.vue's "focus values")
 */

const focusValueIdx = props.focusForm || [
  // idx must match one of the stone_form option keys (see locales/*.json)
  "ROUND",
  "PRINCESS",
  "HEART",
  "BAGUETTE"
]

const getFocusValueIdx = computed(() => {
  if (matchedIdx.value !== -1 && !focusValueIdx.includes(variantsList.value[matchedIdx.value].idx)) {
    return [
      variantsList.value[matchedIdx.value].idx,
      ...focusValueIdx.slice(0, -1)
    ]
  }

  return focusValueIdx
})

// only the values that are part of focusValueIdx should ever be shown; if that list is
// larger than 5, the first 5 are shown directly and the rest are hidden behind "more"
const focusVariantsList = computed(() => getFocusValueIdx.value
    .map((idx: string) => variantsList.value.find((v: any) => v.idx === idx))
    .filter((v: any) => !!v))

const variantsLoaded = computed(() => !!active.value && focusVariantsList.value.length >= minVariantsToShow)

const visibleFocusValues = computed(() => focusVariantsList.value.slice(0, 20))

const moreFocusValues = computed(() => focusVariantsList.value.slice(20))

const hasMoreValues = computed(() => moreFocusValues.value.length > 0)

// whether the "more" values (list entry with the right-arrow) have been revealed inline
const showMore = ref(false)

/**
 * Patch
 */

const handleValuePatch = (actionIdx: string, value: any) => {
  emit('patch', {
    action: actionIdx,
    value: value.idx,
    certificated_diamond: value.certificated_diamond
  });
};


return (_ctx: any,_cache: any) => {
  return (variantsLoaded.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleFocusValues.value, (variantData, variantIdx) => {
            return (_openBlock(), _createElementBlock("li", {
              key: variantIdx,
              class: "cursor-pointer flex flex-col items-center py-2 px-1 rounded-2xl",
              onClick: ($event: any) => (handleValuePatch(active.value.idx, variantData))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["rounded-2xl flex flex-col items-center p-2 hover:bg-[#f3f0e9]", {
               'border-2 border-brand-main bg-[#f3f0e9]': variantData.match,
               'border-2 border-transparent': !variantData.match
             }])
              }, [
                _createElementVNode("img", {
                  src: `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/stone_form/300x300/${variantData.idx.toLowerCase()}.webp`,
                  srcset: `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/stone_form/600x600/${variantData.idx.toLowerCase()}.webp`,
                  class: "max-w-12 w-full h-auto object-contain"
                }, null, 8, _hoisted_4),
                _createElementVNode("span", _hoisted_5, _toDisplayString(variantData.title), 1)
              ], 2)
            ], 8, _hoisted_3))
          }), 128)),
          (hasMoreValues.value && !showMore.value)
            ? (_openBlock(), _createElementBlock("li", {
                key: 0,
                class: "cursor-pointer flex flex-col items-center py-2 px-1 rounded-2xl hover:bg-[#f3f0e9] border-2 border-transparent",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showMore.value = true))
              }, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("div", { class: "h-14 w-14 rounded-2xl flex items-center justify-center relative bg-[#f3f0e9]" }, [
                  _createElementVNode("svg", {
                    "aria-hidden": "true",
                    viewBox: "0 0 12 12",
                    fill: "none",
                    class: "size-2.5 shrink-0 -rotate-90 text-[#555956]"
                  }, [
                    _createElementVNode("path", {
                      d: "m1.5 4 4.5 4 4.5-4",
                      stroke: "currentColor",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    })
                  ])
                ], -1),
                _createElementVNode("span", { class: "text-parameter-text text-[10px] overflow-hidden max-w-14 mx-auto text-center mt-1" }, " Mehr ", -1)
              ]))]))
            : _createCommentVNode("", true),
          (showMore.value)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(moreFocusValues.value, (variantData, variantIdx) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: 'more-' + variantIdx,
                  class: "cursor-pointer flex flex-col items-center py-2 px-1 rounded-2xl",
                  onClick: ($event: any) => (handleValuePatch(active.value.idx, variantData))
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["rounded-2xl flex flex-col items-center p-2 hover:bg-[#f3f0e9]", {
                 'border-2 border-brand-main bg-[#f3f0e9]': variantData.match,
                 'border-2 border-transparent': !variantData.match
               }])
                  }, [
                    _createElementVNode("img", {
                      src: `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/stone_form/300x300/${variantData.idx.toLowerCase()}.webp`,
                      srcset: `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/stone_form/600x600/${variantData.idx.toLowerCase()}.webp`,
                      class: "max-w-12 w-full h-auto object-contain"
                    }, null, 8, _hoisted_7),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(variantData.title), 1)
                  ], 2)
                ], 8, _hoisted_6))
              }), 128))
            : _createCommentVNode("", true),
          (showMore.value)
            ? (_openBlock(), _createElementBlock("li", {
                key: 2,
                class: "cursor-pointer flex flex-col items-center py-2 px-1 rounded-2xl hover:bg-[#f3f0e9] border-2 border-transparent",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (showMore.value = false))
              }, [...(_cache[3] || (_cache[3] = [
                _createElementVNode("div", { class: "h-14 w-14 rounded-2xl flex items-center justify-center relative bg-[#f3f0e9]" }, [
                  _createElementVNode("svg", {
                    "aria-hidden": "true",
                    viewBox: "0 0 12 12",
                    fill: "none",
                    class: "size-2.5 shrink-0 rotate-90 text-[#555956]"
                  }, [
                    _createElementVNode("path", {
                      d: "m1.5 4 4.5 4 4.5-4",
                      stroke: "currentColor",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    })
                  ])
                ], -1),
                _createElementVNode("span", { class: "text-parameter-text text-[10px] overflow-hidden max-w-14 mx-auto text-center mt-1" }, " Weniger ", -1)
              ]))]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})